import { graphql } from '../gql';

/** Document for checking if the OpenAI API is available. Re-exported for consumers that need it. */
export const IS_OPEN_AI_UP = graphql(`
  query IsOpenAiUp {
    isOpenAiUp
  }
`);
